// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // Backend de PRE compartido. Este valor se ha perdido ya tres veces por apuntarlo a un backend
  // local y commitearlo (la última, en el merge afbe62e, que resolvió el conflicto quedándose con
  // el lado de la rama del TPV). Para trabajar contra un backend local, cámbialo y NO lo subas.
  baseUrl: 'https://pre-api.naaora.com/',
  chatbotApiUrl: 'https://frv7enn6va.execute-api.eu-west-1.amazonaws.com',
  posUrl: 'https://pos-dev.naaora.com', // pos-hub de PRE. En local, pos-hub arranca en http://localhost:8081 (el 8080 lo ocupa el backend)
  firebaseConfig : {
    apiKey: "AIzaSyDyW3AEbYhKRBob0YjoT2_SX74hbKUqrAU",
    authDomain: "naaora-dev.firebaseapp.com",
    projectId: "naaora-dev",
    storageBucket: "naaora-dev.firebasestorage.app",
    messagingSenderId: "987286535208",
    appId: "1:987286535208:web:5de9ded473501e9550091d",
    measurementId: "G-28C3GJTWND"
}
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
